const TextareaInput = ({
  value,
  label,
  name,
  placeholder,
  onChange,
  hasError,
  onBlur
}) => (
  <div className="form-group">
    {label && <label htmlFor={name}>{label}</label>}
    <textarea
      value={value}
      name={name}
      id={name}
      className={[
        "form-group__form-control",
        hasError ? "input-error-border" : null,
      ]
        .filter(Boolean)
        .join(" ")}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
    ></textarea>
    {/*  error message here  */}
  </div>
)

export default TextareaInput
